<div class="container-fluid">
    <div class="row header d-flex flex-column justify-content-between align-items-center">
        <div class="col-md-12">
            <h1 class="header-content">
                {{ error.message }}
            </h1>
        </div>
        <div class="col-md-12 d-flex justify-content-center">
            <img class="error-image" [src]="error.image" />
        </div>
    </div>
</div>
